import React from 'react';
import { Create, SimpleForm, Toolbar, ListButton, SaveButton, TextInput} from 'react-admin';
import { onSiteCarouselCreate } from '../../Service/Validation/SiteCarouselValidation'
import { SiteCarouselSiteSelectInput,SiteCarouselNavigationSelectInput,SiteCarouselPageSelectInput, SiteCarouselAnimationSelectInput,SiteCarouselAutoplaySelectInput,SiteCarouselStatusSelectInput } from '../../UI/Input/SelectInput'

const PageTitle = () => {
    return <span>Create Site Carousel</span>;
};

const FormToolbar = props => (
    <Toolbar {...props} >       
        <SaveButton label="Save" redirect="list" submitOnEnter={true} />
        {!props.saving && <ListButton label="Cancel" />}
    </Toolbar>
)

const SiteCarouselCreate = (props) => (
    <Create title={<PageTitle />} {...props} undoable={false}>
        <SimpleForm toolbar={<FormToolbar />} validate={onSiteCarouselCreate}>
        <SiteCarouselSiteSelectInput label="Site" source="site" fullWidth disabled/>
        {/* <SiteCarouselPageSelectInput label="Page" source="page" fullWidth/> */}
        <TextInput label="Page" source="page" fullWidth/>
        <span>In milliseconds eg:1000 = 1 second</span>
        <TextInput label="Speed" source="speed" fullWidth />
        <span>In milliseconds eg:1000 = 1 second</span>
        <TextInput label="Interval Time" source="intervaltime" fullWidth/>
        <SiteCarouselAnimationSelectInput label="Animation" source="animation" fullWidth/>
        <SiteCarouselAutoplaySelectInput label="Autoplay" source="autoplay" fullWidth />
        <SiteCarouselNavigationSelectInput label="Navigation" source="navigation" fullWidth/>
        <SiteCarouselStatusSelectInput label="Status" source="status" fullWidth/>
        </SimpleForm>
    </Create>
);

export default SiteCarouselCreate